import { ExternalLink } from "lucide-react"

interface RisqueDetail {
  libelle?: string
  present?: boolean
}

interface GeorisquesData {
  risquesNaturels?: Record<string, RisqueDetail>
  risquesTechnologiques?: Record<string, RisqueDetail>
  url?: string
}

interface RisquesDetailsProps {
  data: GeorisquesData | null
  error?: unknown
}

export const RisquesDetails = ({ data, error }: RisquesDetailsProps) => {
  if (error) return <div className="text-sm text-destructive pt-2">Erreur de chargement</div>

  const georisquesData = data
  const risquesNaturels = georisquesData?.risquesNaturels
  const risquesTechno = georisquesData?.risquesTechnologiques

  if (!risquesNaturels && !risquesTechno) {
    return <div className="text-sm text-gray-400 pt-2">Aucune donnée de risques disponible</div>
  }

  return (
    <div className="pt-1 space-y-3">
      {risquesNaturels && Object.keys(risquesNaturels).length > 0 && (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5 flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-destructive" />
            Risques naturels
          </div>
          <div className="space-y-1">
            {Object.entries(risquesNaturels).map(([key, detail]: [string, RisqueDetail | undefined]) =>
              detail ? (
                <div key={key} className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">{detail.libelle || key}</span>
                  <span className={detail.present ? "text-destructive font-medium" : "text-gray-400"}>
                    {detail.present ? "Présent" : "Absent"}
                  </span>
                </div>
              ) : null,
            )}
          </div>
        </div>
      )}

      {risquesTechno && Object.keys(risquesTechno).length > 0 && (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5 flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-amber-500" />
            Risques technologiques
          </div>
          <div className="space-y-1">
            {Object.entries(risquesTechno).map(([key, detail]: [string, RisqueDetail | undefined]) =>
              detail ? (
                <div key={key} className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">{detail.libelle || key}</span>
                  <span className={detail.present ? "text-destructive font-medium" : "text-gray-400"}>
                    {detail.present ? "Présent" : "Absent"}
                  </span>
                </div>
              ) : null,
            )}
          </div>
        </div>
      )}

      {georisquesData?.url && (
        <a
          href={georisquesData.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary/80"
        >
          Voir le rapport Géorisques
          <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </div>
  )
}
